export default __webpack_public_path__ + "static/media/titleResourceCenter.50d26b02.svg";